import angular from 'angular';
import nsjGlobals from '../../core/globals/nsj-globals';

/**
 * Service que apoia a regra de negócios estabelecida aqui em permissão
 * Nele é obtido se um determinado móduto do sistema está habilitado ou não
 * Apenas algumas áreas do sistema possuem essa configuração
 */
export class PermissaoService {

    static $inject = [];

    temConfiguracao(configuracao: string) {
        const configs = nsjGlobals.get('configuracoes');

        if (!configs) {
            return false;
        }

        return configs.hasOwnProperty(configuracao) && configs[configuracao] ? true : false;
    }

    temPermissao(permissao: string | string[]) {
        const permissoes = nsjGlobals.get('permissoes');

        if (!permissoes) {
            return false;
        }

        if (typeof permissao === 'string') {
            return permissoes.hasOwnProperty(permissao);
        }

        if (Array.isArray(permissao)) {
            return permissao.some(item => permissoes.hasOwnProperty(item));
        }

        return false;
    }

    temPermissaoGrupoEmpresarial(permissoes: string[], grupoCodigo: string) {
        const permissoesAgrupadas = nsjGlobals.get('permissoesagrupadas');

        if (!permissoesAgrupadas) {
            return false;
        }

        const gruposEmpresariais = permissoesAgrupadas.gruposempresariais as {
            codigo: string,
            permissoes: { [key: string]: boolean }
        }[];

        const grupoSelecionado = gruposEmpresariais.find((grupo) => grupo.codigo === grupoCodigo);

        if (grupoSelecionado) {
            return !permissoes.some(permissao => !grupoSelecionado.permissoes.hasOwnProperty(permissao));
        }

        return false;
    }

    modoGestorPermissao(permissao: string | string[]) {
        const permissoes = nsjGlobals.get('permissoes') as Record<string, boolean> | null;

        if (!permissoes) {
            return false;
        }

        if (typeof permissao === 'string') {
            return permissoes[permissao] ? true : false;
        }

        if (Array.isArray(permissao)) {
            return permissao.some(item => permissoes[item]);
        }

        return false;
    }

    isAdmin() {
        return nsjGlobals.get('isAdmin');
    }

    liberadoTela(permissao: string) {
        const habilitados = nsjGlobals.get('habilitados') as Record<string, boolean> | null;

        if (!habilitados) {
            return false;
        }

        return habilitados.hasOwnProperty(permissao) ? habilitados[permissao] : false;
    }

    soPossuiPonto() {
        return nsjGlobals.get('soPossuiPontoweb');
    }
}

angular.module('main').service('PermissaoService', PermissaoService);
